// export const BASE_URL = 'https://joy-juncture.onrender.com';
export const BASE_URL = 'https://api-prod.joyjuncture.com';
// export const BASE_URL = 'http://localhost:8084';
